module.exports = __webpack_public_path__ + "static/media/facebook.4c5d1ef2.svg";